<template>
  <div>
    <FunBookV2OrderDetailPage :order="order" />
  </div>
</template>

<script>
import FunBookV2OrderDetailPage from '@/components/FunBookV2OrderDetailPage.vue'
import { useOrderDetailPage } from '@/composition/useOrder'

export default defineComponent({
  name: 'FunBookOrderDetailStrategyPage',
  components: {
    FunBookV2OrderDetailPage,
  },
  setup() {
    useHead({
      meta: [{ name: 'robots', content: 'noindex' }],
    })
    const { order } = useOrderDetailPage()

    return {
      order,
    }
  },
})
</script>
